/**
 * ダッシュボード関連の定数定義
 */
// ViewMode type imported but not used in this file - available for future use
// import type { ViewMode } from '../types/schedule';

/**
 * スケジュール表示関連の定数
 */
export const SCHEDULE_CONSTANTS = {
  /** デフォルトの搬入時間（搬入日の開始時間） */
  DEFAULT_DELIVERY_START_TIME: '08:00',
  /** デフォルトの移送終了時間 */
  DEFAULT_TRANSIT_END_TIME: '18:00',
  /** 空のスケジュールメッセージ */
  EMPTY_SCHEDULE_MESSAGE: '今日は割り当てられた案件がありません。',
} as const;

/**
 * 案件ステータス表示テキスト
 * FL-142: 8状態に拡張
 */
export const CASE_STATUS_LABELS = {
  provisional: '仮受',
  confirmed: '本受・未配車',
  assigned: '配車済み',
  picked_up: '引き取り済み',
  in_transit: '輸送中',
  delivered: '搬入済み',
  reported: '報告済み',
  completed: '完了',
} as const;

/**
 * 案件ステータスアクション表示テキスト
 */
export const CASE_STATUS_ACTIONS = {
  START_WORK: '作業開始',
  COMPLETE_WORK: '完了報告',
} as const;

/**
 * ダッシュボード統計表示テキスト
 */
export const DASHBOARD_STATS_LABELS = {
  COMPLETION_RATE: '完了率',
  COMPLETED: '完了',
  IN_TRANSIT: '作業中',
  ASSIGNED: '待機',
} as const;

/**
 * 案件タイプ表示ラベル
 */
export const CASE_TYPE_LABELS = {
  pickup: '引取',
  delivery: '搬入',
  transit: '移送中',
  pickup_delivery: '引取・搬入', // 同日引取・搬入の場合
  unknown: '未定',
} as const;

/**
 * 特記事項表示テキスト
 */
export const REMARKS_LABELS = {
  TITLE: '特記事項',
  URGENT_KEYWORD: '緊急',
} as const;

/**
 * ビューモード関連の定数
 */
export const VIEW_MODE = {
  DRIVER: 'driver',
  ADMIN: 'admin',
} as const;
